import ptBrPsiTranslations from './pt-brPsi';
import ptBrTranslations from './pt-br';
import enUsTranslations from './en-us';
import enTranslations from './es';

export type Translations = keyof typeof ptBrTranslations;

export const defaultTranslations = {
  // Brazil
  'pt-BR': ptBrTranslations,
  'pt-br': ptBrTranslations,

  // Portugal
  pt: ptBrTranslations,
  PT: ptBrTranslations,
  'pt-PT': ptBrTranslations,
  'pt-pt': ptBrTranslations,

  // Unites States
  en: enUsTranslations,
  EN: enUsTranslations,
  'en-US': enUsTranslations,
  'en-us': enUsTranslations,

  // Spain
  es: enTranslations,
  ES: enTranslations,
  'es-ES': enTranslations,
  'es-es': enTranslations,

  // Dominican Republic
  'es-DO': enTranslations,
  'es-do': enTranslations,

  // Guatemala
  'es-GT': enTranslations,
  'es-gt': enTranslations,

  // Honduras
  'es-HN': enTranslations,
  'es-hn': enTranslations,

  // México
  'es-MX': enTranslations,
  'es-mx': enTranslations,

  // Panamá
  'es-PA': enTranslations,
  'es-pa': enTranslations,

  // Peru
  'es-PE': enTranslations,
  'es-pe': enTranslations,

  // Sweden
  'es-SV': enTranslations,
  'es-SE': enTranslations,
  'es-sv': enTranslations,
  'es-se': enTranslations,
};

export const psiTranslations = {
  ...defaultTranslations,
  'pt-BR': ptBrPsiTranslations,
  'pt-br': ptBrPsiTranslations,
};
